<template>
    <div class="records-content-wrapper">
        <div class="records-content-inner">
            <div class="banner">
                <h1 class="banner-title">
                    <b>第八届中国(绵阳)科技城<br>国际科技博览会</b>
                    <span>CHINA (MIANYANG) SCIENCE&amp;TECHNOLOGY CITY INTERNATIONAL HIGH-TECH EXPO</span>
                </h1>
                <div class="records-title">
                    <span>{{$tc('footprint.title')}}</span>
                </div>
            </div>
            <div class="content">
                <h5>{{$tc('footprint.content1')}} <span>{{startTime}}</span> {{$tc('footprint.content2')}}</h5>
                <p>{{$tc('footprint.content3')}} <span>{{recordsdata.visitCount || 0}}</span> {{$tc('footprint.content4')}}</p>
                <div class="has-exhibits" v-if="recordsdata.visitExhibitCount">
                    <p>{{(recordsdata.visitPavilionCount || recordsdata.visitExhibitionAreaCount) ? $tc('footprint.content5') + ' ' : ''}}<span v-if="recordsdata.visitExhibitionAreaCount">{{recordsdata.visitExhibitionAreaCount}}</span>{{recordsdata.visitExhibitionAreaCount ? ' ' + $tc('footprint.content6') : ''}}{{(recordsdata.visitPavilionCount && recordsdata.visitExhibitionAreaCount) ? ' ' + $tc('footprint.content13') : ''}}<span v-if="recordsdata.visitPavilionCount">{{recordsdata.visitPavilionCount}}</span>{{recordsdata.visitPavilionCount ? ' ' + $tc('footprint.content7') : ''}}</p>
                    <p>{{$tc('footprint.content8')}} <span>{{recordsdata.visitExhibitCount || 0}}</span> {{$tc('footprint.content9')}}</p>
                    <p>{{$tc('footprint.content10')}} <span>{{recordsdata.watchTime || 0}}</span> {{$tc('footprint.content11')}}</p>
                </div>
                <div class="no-exhibits" v-else>
                    <p>{{(recordsdata.visitPavilionCount || recordsdata.visitExhibitionAreaCount) ? $tc('footprint.content5') + ' ' : ''}}<span v-if="recordsdata.visitExhibitionAreaCount">{{recordsdata.visitExhibitionAreaCount}}</span>{{recordsdata.visitExhibitionAreaCount ? ' ' + $tc('footprint.content6') : ''}}{{(recordsdata.visitPavilionCount && recordsdata.visitExhibitionAreaCount) ? ' ' + $tc('footprint.content13') : ''}}<span v-if="recordsdata.visitPavilionCount">{{recordsdata.visitPavilionCount}}</span>{{recordsdata.visitPavilionCount ? ' ' + $tc('footprint.content7') : ''}}</p>
                    <p>{{$tc('footprint.content12')}}</p>
                </div>
            </div>
            <div class="exhibits">
                <div class="img">
                    <img id="exhibit_url" :src="exhibitUrl" @error="exhibitUrlError" alt="">
                </div>
                <h4>{{recordsdata.exhibitName}}</h4>
                <p>{{recordsdata.exhibitionPositionName}}</p>
            </div>
            <div class="btn" @click="drawImg">{{$tc('footprint.share')}}<i class="iconfont iconxiayiyedanjiantou"></i></div>
        </div>
        <!-- 海报蒙层 -->
        <div class="poster-mask" v-if="drawPosterFlag">
            <div class="poster-mask-content" :class="[posterClass]" v-if="!isDrawing">
                <div class="poster-img-wrap">
                    <div class="poster-img-inner">
                        <img id="poster_img" :src="shareImg" alt="" />
                    </div>
                    <div class="poster-close" @click="closePosterMask">
                        <img src="../../assets/img/close.png" alt=""/>
                    </div>
                    <span class="poster-text">{{$tc('footprint.save')}}</span>
                </div>
            </div>
            <div class="poster-mask-loading" v-if="isDrawing">
                {{$tc('footprint.imgLoaing')}}
            </div>
        </div>
    </div>
</template>

<script>

import Moment from 'moment'

import { mapMutations } from 'vuex'

export default {
    name: 'Content',
    data () {
        return {
            isDrawing: false,
            shareImg: '',
            drawPosterFlag: false,
            posterClass: '',
            startTime: '',
            exhibitUrl: '',
            isAndroid: false
        }
    },
    props: ['recordsdata'],
    created () {
        this.startTime = Moment(this.recordsdata.startTime).format('YYYY.MM.DD HH:mm')
        this.exhibitUrl = this.recordsdata.exhibitUrl || require('../../assets/img/records_default_zp.jpg')
    },
    mounted () {
        this.isAndroid = this.$Common.Attribute.isAndroid()
    },
    methods: {
        ...mapMutations(['setToastData']),
        drawImg () {
            if (this.isDrawing) return
            this.drawPosterFlag = true
            if (this.shareImg) {
                setTimeout(() => {
                    this.posterClass = 'show'
                }, 300)
                return
            }
            this.isDrawing = true
            const c = document.createElement('canvas')
            const ctx = c.getContext('2d')
            Promise.all([this.defPreImage(require((window.location.host === 'kbh.thecover.cn') ? '../../assets/img/share_bg.jpg' : '../../assets/img/share_dev_bg.jpg')), this.defPreImage(require('../../assets/img/exhibits_bg.png')), this.defPreImage(document.querySelector('#exhibit_url').src)]).then((imgs) => {
                c.width = imgs[0].width
                c.height = imgs[0].height
                ctx.drawImage(imgs[0], 0, 0, imgs[0].width, imgs[0].height, 0, 0, imgs[0].width, imgs[0].height)
                const content = document.querySelector('.records-content-wrapper .content')
                const contentTile = content.querySelector('h5')
                const contentP = content.querySelectorAll('p')
                this.splitText(contentTile.innerHTML, c, ctx, [
                    {
                        size: 34,
                        top: 688
                    },
                    {
                        size: 42,
                        top: 684
                    }
                ])
                contentP.forEach((element, index) => {
                    this.splitText(element.innerHTML, c, ctx, [
                        {
                            size: 38,
                            top: 770 + index * 76
                        },
                        {
                            size: 54,
                            top: 762 + index * 76
                        }
                    ])
                })
                ctx.drawImage(imgs[1], 0, 0, imgs[1].width, imgs[1].height, 260, 1084, imgs[1].width, imgs[1].height)
                ctx.drawImage(imgs[2], 0, 0, imgs[2].width, imgs[2].height, 303, 1110, 467, 263)
                this.writeText(ctx, this.$t('footprint.title'), {
                    font: '38px "yanhei-Regular",',
                    align: 'center',
                    baseline: 'top',
                    color: '#38eaff'
                }, 1000, c.width / 2, this.isAndroid ? 507 : 500)
                this.writeText(ctx, this.$t('footprint.code'), {
                    font: '28px',
                    align: 'center',
                    baseline: 'top',
                    color: '#fff'
                }, 1000, 958, 1857)
                this.writeText(ctx, document.querySelector('.records-content-wrapper .exhibits h4').innerText, {
                    font: '38px',
                    align: 'center',
                    baseline: 'top',
                    color: '#fff'
                }, 1000, c.width / 2, 1430)
                this.writeText(ctx, document.querySelector('.records-content-wrapper .exhibits p').innerText, {
                    font: 'bold 38px',
                    align: 'center',
                    baseline: 'top',
                    color: '#fff'
                }, 1000, c.width / 2, 1488)
                this.shareImg = c.toDataURL('image/jpeg')
                this.isDrawing = false
                this.$nextTick(() => {
                    setTimeout(() => {
                        this.posterClass = 'show'
                    }, 300)
                })
            }).catch(() => {
                this.setToastData({
                    text: this.$t('footprint.imgerror')
                })
            })
        },
        splitText (html, c, ctx, arr) {
            const textArr = html.split('<span>').join('--').split('</span>').join('--').split('--')
            let lineW = 0
            const linWArr = []
            const spanIndex = []
            html.split('<span>').forEach((v, i) => {
                if (i > 0) {
                    spanIndex.push(i * 2 - 1)
                }
            })
            textArr.forEach((val, idx) => {
                let w = 0
                if (spanIndex.includes(idx)) {
                    ctx.font = `bold ${arr[1].size}px "Helvetica", "PingFang SC","Helvetica Neue",STHeiti,"Microsoft Yahei",Tahoma,Simsun,sans-serif`
                    w = ctx.measureText(val).width
                    lineW = lineW + w
                } else {
                    ctx.font = `${arr[0].size}px "Helvetica", "PingFang SC","Helvetica Neue",STHeiti,"Microsoft Yahei",Tahoma,Simsun,sans-serif`
                    w = ctx.measureText(val).width
                    lineW = lineW + w
                }
                linWArr.push(w)
            })
            textArr.forEach((val, idx) => {
                let l = (c.width - lineW) / 2
                linWArr.forEach((v, i) => {
                    if (i < idx) {
                        l = l + v
                    }
                })
                ctx.textAlign = 'left'
                ctx.textBaseline = 'top'
                if (spanIndex.includes(idx)) {
                    ctx.font = `bold ${arr[1].size}px "Helvetica", "PingFang SC","Helvetica Neue",STHeiti,"Microsoft Yahei",Tahoma,Simsun,sans-serif`
                    ctx.fillStyle = '#00e4ff'
                    ctx.fillText(val, l, arr[1].top)
                } else {
                    ctx.font = `${arr[0].size}px "Helvetica", "PingFang SC","Helvetica Neue",STHeiti,"Microsoft Yahei",Tahoma,Simsun,sans-serif`
                    ctx.fillStyle = '#fff'
                    ctx.fillText(val, l, arr[0].top)
                }
            })
        },
        // 写字
        writeText (ctx, text, textStyle, width, left, top, lineHeight) {
            ctx.font = `${textStyle.font} "Helvetica", "PingFang SC","Helvetica Neue",STHeiti,"Microsoft Yahei",Tahoma,Simsun,sans-serif`
            ctx.textAlign = textStyle.align
            ctx.textBaseline = textStyle.baseline
            ctx.fillStyle = textStyle.color
            let line = ''
            if (lineHeight) {
                for (let n = 0; n < text.length; n++) {
                    const textLine = line + text[n]
                    const metrics = ctx.measureText(textLine)
                    const textWidth = metrics.width
                    if (textWidth > width && n > 0) {
                        if ('，！。？；《'.indexOf(text[n]) > -1) {
                            ctx.fillText(line.slice(0, n - 1), left, top)
                            line = `${text[n - 1]}${text[n]}`
                        } else {
                            ctx.fillText(line, left, top)
                            line = text[n]
                        }
                        top += lineHeight
                    } else {
                        line = textLine
                    }
                }
            } else {
                for (let n = 0; n < text.length; n++) {
                    const textLine = line + text[n]
                    const metrics = ctx.measureText(textLine)
                    const textWidth = metrics.width
                    if (textWidth > width && n > 0) {
                        line = `${line.slice(0, n - 1)}...`
                        break
                    } else {
                        line = textLine
                    }
                }
            }
            ctx.fillText(line, left, top)
            return ctx.measureText(line).width
        },
        // 加载图片
        defPreImage (url) {
            return new Promise((resolve, reject) => {
                const img = new Image()
                img.crossOrigin = 'Anonymous'
                img.src = url
                img.onload = () => {
                    resolve(img)
                }
            })
        },
        exhibitUrlError (e) {
            e.target.src = require('../../assets/img/records_default_zp.jpg')
        },
        closePosterMask () {
            this.posterClass = 'hide'
            setTimeout(() => {
                this.posterClass = ''
                this.drawPosterFlag = false
            }, 300)
        }
    }
}
</script>

<style lang="scss">
    .records-content-wrapper {
        font-size: 0;
        background: url('../../assets/img/records_banner.jpg') no-repeat center top;
        background-size: cover;
        padding-bottom: 20vw;
        text-align: center;
        .banner {
            text-align: center;
            .year {
                font-family: 'yanhei-Regular';
                position: relative;
                line-height: 1.2;
                padding-top: 5vw;
                span {
                    font-size: 17.685vw;
                    color: #57B5FF;
                    opacity: 0.25;
                }
                b {
                    font-size: 12.593vw;
                    color: #fff;
                    position: absolute;
                    left: 50%;
                    top: 8.407vw;
                    transform: translateX(-50%);
                    font-weight: normal;
                }
            }
            .banner-title {
                padding-top: 13.111vw;
                font-family: 'yanhei-Regular';
                line-height: 1.2;
                color: #fff;
                font-weight: normal;
                margin-bottom: 4vw;
                b {
                    font-size: 7.407vw;
                    display: block;
                    line-height: 1.4;
                    margin-bottom: 2.315vw;
                    font-weight: normal;
                    text-shadow:0.185vw 0.648vw 9.444vw #002f7a;
                }
                span {
                    font-size: 2.87vw;
                    display: block;
                    margin-bottom: 1.389vw;
                    text-shadow: 0.185vw 0.648vw 5.444vw #000;
                }
            }
            .records-title {
                font-family: 'yanhei-Regular';
                font-size: 3.519vw;
                display: inline-flex;
                align-items: center;
                justify-content: center;
                height: 6.204vw;
                color: #38EAFF;
                padding: 0 5.556vw;
                background-color: rgba(0, 47, 98, .5);
                position: relative;
                min-width: 34.259vw;
                box-sizing: border-box;
                white-space: nowrap;
                span {
                    padding-bottom: 1vw;
                }
                &::before, &::after {
                    content: '';
                    position: absolute;
                    width: 0;
                    height: 0;
                    border: 1.481vw solid;
                    border-color: transparent transparent transparent #00E4FF;
                }
                &::before {
                    left: 3.704vw;
                }
                &::after {
                    right: 3.704vw;
                    transform: rotate(180deg);
                }
            }
        }
        .content {
            padding-top: 8.704vw;
            text-align: center;
            color: #fff;
            font-size: 3.519vw;
            line-height: 1.4;
            span {
                color: #00e4ff;
                font-size: 5vw;
                font-weight: bold;
            }
            h5 {
                font-size: 3.148vw;
                font-weight: normal;
                margin-bottom: 1.852vw;
                span {
                    font-size: 3.889vw;
                }
            }
            p {
                margin-bottom: 0.926vw;
            }
        }
        .exhibits {
            text-align: center;
            padding: 2.778vw 0 7.13vw;
            .img {
                width: 51.204vw;
                height: 29.815vw;
                background: url('../../assets/img/exhibits_bg.png') no-repeat center center;
                background-size: 100% 100%;
                margin: 0 auto;
                text-align: center;
                box-sizing: border-box;
                padding-top: 2.315vw;
                img {
                    width: 44.074vw;
                    height: 24.352vw;
                }
            }
            h4 {
                font-size: 3.519vw;
                color: #fff;
                line-height: 1.4;
                margin-top: 1.296vw;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                word-wrap: break-word;
                padding: 0 2vw;
            }
            p {
                color: #fff;
                font-size: 3.519vw;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                word-wrap: break-word;
                line-height: 1.4;
                margin-top: 0.463vw;
            }
        }
        .btn {
            background-color: #00daff;
            padding: 0 3.148vw;
            font-size: 3.796vw;
            color: $color;
            display: inline-flex;
            align-items: center;
            font-weight: bold;
            height: 8.056vw;
            i {
                font-size: 4.63vw;
            }
        }

        .poster-mask {
            position: fixed;
            width: 100%;
            height: 100%;
            left: 0;
            top: 0;
            background-color: rgba(0, 0, 0, 0.8);
            z-index: 20;
            overflow: hidden;
        }
        .poster-mask img {
            width: 100%;
        }
        .poster-mask-loading {
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 4vw;
            color: #fff;
        }
        .poster-mask-content {
            height: 100%;
            position: relative;
            overflow: hidden;
        }
        .poster-img-wrap {
            width: 76.8%;
            height: 76.875vh;
            margin: 9.8vh auto 0;
            position: relative;
            transform: scale(0);
            transition: all 0.3s;
        }
        .poster-mask-content.show .poster-img-wrap {
            transform: scale(1);
        }
        .poster-mask-content.hide .poster-img-wrap {
            transform: scale(0);
        }
        .poster-img-inner {
            height: 100%;
            text-align: center;
        }
        .poster-img-inner img {
            max-width: 100%;
            width: auto;
            max-height: 100%;
        }
        .poster-close {
            width: 8.05vw;
            position: absolute;
            right: -4.8vw;
            top: -4.8vw;
            z-index: 2;
            cursor: pointer;
            padding: 2vw;
        }
        .poster-text {
            font-size: 3.704vw;
            color: #fff;
            height: 9.259vw;
            align-items: center;
            display: inline-flex;
            padding: 0 4.259vw;
            border: 1px solid #fff;
            border-radius: 0.926vw;
            line-height: 1.3;
            margin-top: 3.6vh;
        }
    }
</style>
